//its the main code 

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";
import "../Ledger/UpdateLedger.css";

function NewUser() {
  const [companyList, setCompanyList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Form states
  const [selectedCompany, setSelectedCompany] = useState("");
  const [loginId, setLoginId] = useState(""); // Start with empty value
  const [password, setPassword] = useState(""); // Start with empty value
  const [showPassword, setShowPassword] = useState(false);
  const [userType, setUserType] = useState("1");
  const [MasterId, setUserID] = useState("");
  const [Active, setActive] = useState(1);
  const loggedInUserId = localStorage.getItem("userId");

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  const fetchData = async () => {
    setError(null);
    setLoading(true);

    const data = new URLSearchParams();
    data.append("SecurityKey", SECURITY_KEY);
    data.append("TableName", "company");
    data.append("WhereCondition", `MasterId=${loggedInUserId}`);
    data.append("*", "*");

    try {
      const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });

      if (!response.ok) throw new Error(`HTTP Error! Status: ${response.status}`);

      const jsonData = await response.json();

      if (jsonData.Response) {
        setCompanyList(jsonData.Response);
      } else {
        setError("No company data found.");
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
      setError("Failed to fetch company list.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedLoginid = localStorage.getItem("userId");
    if (storedLoginid) setUserID(storedLoginid);
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const formData = new URLSearchParams();
    formData.append("SecurityKey", SECURITY_KEY);
    formData.append("TableName", "users");
    formData.append("CompId", selectedCompany);
    formData.append("LoginID", loginId);
    formData.append("password", password);
    formData.append("userType", userType);
    formData.append("MasterId", MasterId);
    formData.append("Active", Active);

    const apiUrl = `${BASE_REST_API_URL}/insertdata.aspx`;

    try {
      setLoading(true);

      const res = await apiWithLog({
        method: "POST",
        url: apiUrl,
        data: formData.toString(),
        module: "User",
        action: "A",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      let result = res.data;

      if (typeof result === "string") {
        console.log("Raw Response:", result);

        const text = result.toLowerCase();

        if (
          text.includes("success") ||
          text.includes("ok") ||
          text.includes("insert")
        ) {
          showToast.save("User added successfully!");
        } else {
          showToast.error("Failed to add user");
          return;
        }
      } else {
        if (result?.status || res.status === 200) {
          showToast.save("User added successfully!");
        } else {
          showToast.error(result?.message || "Failed to add user");
          return;
        }
      }

      console.log("✅ Data Inserted Successfully:", result);

      setSelectedCompany("");
      setLoginId("");
      setPassword("");

      setTimeout(() => {
        navigate("/users");
      }, 1200);

    } catch (error) {
      console.error("Error inserting data:", error);
      showToast.error("Failed to add user");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Add User</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/users">Users</Link>
            <span>/</span>
            <span>New</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>User Information</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            <div className="update_ledger_field">
              <label htmlFor="selectedCompany">
                Select Company <span className="required">*</span>
              </label>
              <select
                id="selectedCompany"
                required
                value={selectedCompany}
                onChange={(e) => setSelectedCompany(e.target.value)}
              >
                <option value="">-- Select Company Name --</option>
                {companyList.map((company, index) => (
                  <option key={index} value={company.CompID}>
                    {company.Name || company.CompanyName}
                  </option>
                ))}
              </select>
            </div>

            <div className="update_ledger_field">
              <label htmlFor="loginId">
                Login Id <span className="required">*</span>
              </label>
              <input
                id="loginId"
                type="text"
                placeholder="Enter Login Id"
                required
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                autoComplete="new-password"
              />
            </div>

            <div className="update_ledger_field">
              <label htmlFor="password">
                Password <span className="required">*</span>
              </label>
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  style={{ width: "100%", paddingRight: "36px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  title={showPassword ? "Click to hide password" : "Click to view password"}
                  style={{
                    position: "absolute",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    color: showPassword ? "#0d9488" : "#64748b",
                    cursor: "pointer",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  tabIndex="-1"
                >
                  <i className={showPassword ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"}></i>
                </button>
              </div>
            </div>

            <div className="update_ledger_field d-none">
              <label>UserType</label>
              <input
                type="text"
                placeholder="UserType"
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
              />
            </div>

            <div className="update_ledger_field d-none">
              <label>Master Id</label>
              <input
                type="text"
                placeholder="Master Id"
                value={MasterId}
                onChange={(e) => setUserID(e.target.value)}
              />
            </div>

            <div className="update_ledger_field d-none">
              <label>Active</label>
              <input
                type="text"
                placeholder="Active"
                value={Active}
                onChange={(e) => setActive(e.target.value)}
              />
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/users" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Saving..." : "Save User"}
            </button>
          </div>

          {error && <p style={{ color: "#dc2626", marginTop: "10px", fontSize: "13px" }}>{error}</p>}
        </form>
      </div>
    </div>
  );
}

export default NewUser;


// import React, { useEffect, useState } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";
// import { useNavigate } from "react-router-dom";

// function NewUser() {
//   const [companyList, setCompanyList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   // Form states
//   const [selectedCompany, setSelectedCompany] = useState("");
//   const [loginId, setLoginId] = useState("");
//   const [password, setPassword] = useState("");
//   const [userType, setUserType] = useState("1");
//   const [MasterId, setUserID] = useState("");
//   const [Active, setActive] = useState(1);

//   const fetchData = async () => {
//   setError(null);
//   setLoading(true);

//     const data = new URLSearchParams();
//     // data.append("SecurityKey", "abcd");
//     data.append("SecurityKey", SECURITY_KEY);
//     data.append("TableName", "Company");
//     data.append("WhereCondition", "All");
//     data.append("*", "*");


//   try {
//     const apiUrl = "http://localhost:5000/api/user/dropdowns";

//     const response = await fetch(apiUrl, {
//       method: "GET",
//       headers: { "Content-Type": "application/json" },
//     });

//     if (!response.ok)
//       throw new Error(`HTTP Error! Status: ${response.status}`);

//     const jsonData = await response.json();

//     if (jsonData && Array.isArray(jsonData)) {
//       setCompanyList(jsonData); // ✅ Directly set the array
//     } else {
//       setError("No company data found.");
//     }
//   } catch (error) {
//     console.error("Error fetching company data:", error);
//     setError("Failed to fetch company list.");
//   } finally {
//     setLoading(false);
//   }
// };


//   useEffect(() => {
//     const storedLoginid = localStorage.getItem("userId");
//     if (storedLoginid) setUserID(storedLoginid);
//   }, []);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!selectedCompany || !loginId || !password) {
//       toast.error("Please fill all required fields!");
//       return;
//     }

//     const formData = new URLSearchParams();
//     formData.append("CompId", selectedCompany);
//     formData.append("SecurityKey", SECURITY_KEY);
//     formData.append("LoginID", loginId);
//     formData.append("Password", password); // Plain text password
//     formData.append("UserType", userType);
//     formData.append("Masterid", MasterId);
//     formData.append("Active", Active);

//     try {
//       const response = await fetch("http://localhost:5000/api/user/create_user", {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         body: formData.toString(),
//       });

//       const result = await response.json();

//       if (!response.ok) {
//         throw new Error(result.error || `HTTP Error! Status: ${response.status}`);
//       }

//       toast.success("User added successfully!", { position: "top-center", autoClose: 2000 });

//       // Clear form
//       setSelectedCompany("");
//       setLoginId("");
//       setPassword("");

//       // Redirect after short delay
//       setTimeout(() => {
//         navigate("/users");
//       }, 2000);
//     } catch (err) {
//       console.error("Error inserting user:", err);
//       toast.error(`Failed to add user: ${err.message}`, { position: "top-center", autoClose: 3000 });
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-center" autoClose={2000} />

//       <form
//         className="compney_form"
//         onSubmit={handleSubmit}
//         encType="multipart/form-data"
//       >
//         <h5 className="text-center font-bold m-3">Users Data</h5>

//         <div className="compney_input_div">
//           <label className="mb-2">Select Company</label>
//           <select
//             required
//             value={selectedCompany}
//             onChange={(e) => setSelectedCompany(e.target.value)}
//           >
//             <option value="">Select Company Name</option>
//             {companyList.map((company, index) => (
//               <option key={index} value={company.CompID}>
//                 {company.CompanyName}  {/* ✅ Correct key from API response */}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Login Id</label>
//           <input
//             type="text"
//             placeholder="Login Id"
//             required
//             value={loginId}
//             onChange={(e) => setLoginId(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div">
//           <label className="mb-2">Password</label>
//           <input
//             type="password"
//             placeholder="Password"
//             required
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div d-none">
//           <label>UserType</label>
//           <input
//             type="text"
//             placeholder="UserType"
//             required
//             value={userType}
//             onChange={(e) => setUserType(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div d-none">
//           <label>Master Id</label>
//           <input
//             type="text"
//             placeholder="Master Id"
//             required
//             value={MasterId}
//             onChange={(e) => setUserID(e.target.value)}
//           />
//         </div>

//         <div className="compney_input_div d-none">
//           <label>Active</label>
//           <input
//             type="text"
//             placeholder="Active"
//             required
//             value={Active}
//             onChange={(e) => setActive(e.target.value)}
//           />
//         </div>

//         <button type="submit">Submit</button>

//         {loading && <p>Loading companies...</p>}
//         {error && <p style={{ color: "red" }}>{error}</p>}
//       </form>
//     </div>
//   );
// }

// export default NewUser;
